import * as React from 'react';

import type { ButtonProps } from '@blueprintjs/core';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { EvenButton } from './EvenButton';

export const ViewMoreButton: React.FC<React.PropsWithChildren<ButtonProps>> = ({
  children = 'View More',
  ...rest
}) => {
  return (
    <EvenButton
      outlined
      rightIcon={<FontAwesomeIcon icon={faArrowRight} size="xs" />}
      {...rest}
    >
      {children}
    </EvenButton>
  );
};
